module.exports = __webpack_public_path__ + "static/media/sachticky.dcfadccf.jpg";